import { Spinner } from 'react-bootstrap';
import { styled } from 'styled-components';

const BlueSpinner = styled(Spinner)`
  color: #008AFF;
`;

export default BlueSpinner;
